document.addEventListener('DOMContentLoaded', function () {
    // 切り替える対象にclass属性。
    var elems = document.querySelectorAll('.video_switch');

    // 切り替えの対象のsrc属性の末尾の文字列。
    var sp = '_sp.';
    var pc = '_pc.';

    // 画像を切り替えるウィンドウサイズ。
    var replaceWidth = 768;

    function imageSwitch() {
        // ウィンドウサイズを取得する。
        var windowWidth = parseInt(window.innerWidth);

        // ページ内にあるすべての`.switch`に適応される。
        elems.forEach(function (elem) {
            var src = elem.getAttribute('src');
            // ウィンドウサイズが768px以上であれば_spを_pcに置換する。
            if (windowWidth >= replaceWidth) {
                elem.setAttribute('src', src.replace(sp, pc));
            } else {
                // ウィンドウサイズが768px未満であれば_pcを_spに置換する。
                elem.setAttribute('src', src.replace(pc, sp));
            }
        });
    }

    imageSwitch();

    // 動的なリサイズは操作後0.2秒経ってから処理を実行する。
    var resizeTimer;
    window.addEventListener('resize', function () {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function () {
            imageSwitch();
        }, 200);
    });

    // Videoタグに今使用されている動画の情報をコンソールに出力する関数
    function logCurrentVideo() {
        elems.forEach(function (elem) {
            if (elem.nodeName === 'VIDEO') {
                console.log('Current video source: ', elem.currentSrc);
            }
        });
    }

    // ページの読み込みが完了した時にlogCurrentVideo関数を呼び出す
    logCurrentVideo();
});


//------------------
// ビデオタグのダウンロードを防ぐ
//------------------
// Videoタグに属性を追加する関数
function addAttributesToVideoTags() {
    var videoTags = document.getElementsByTagName('video');
    for (var i = 0; i < videoTags.length; i++) {
        videoTags[i].setAttribute('controlsList', 'nodownload');
        videoTags[i].setAttribute('oncontextmenu', 'return false;');
    }
}

// .modaal-video要素の監視を開始する関数
function observeModaalVideo() {
    // .modaal-video要素を監視するオブザーバーを作成
    var observer = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
            var addedNodes = mutation.addedNodes;
            for (var i = 0; i < addedNodes.length; i++) {
                var addedNode = addedNodes[i];
                if (addedNode.classList && addedNode.classList.contains('modaal-video')) {
                    // .modaal-video要素が追加された場合に処理を実行
                    addAttributesToVideoTags();
                    break;
                }
            }
        });
    });

    // .modaal-video要素の親要素を監視対象とする（例えばbody要素など）
    var targetNode = document.body;

    // オブザーバーの設定
    var config = { childList: true, subtree: true };

    // オブザーバーの開始
    observer.observe(targetNode, config);
}

// Videoタグに属性を追加
addAttributesToVideoTags();

// .modaal-video要素の監視を開始
observeModaalVideo();

// ページロード後に再度Videoタグに属性を追加する
window.addEventListener('load', function () {
    addAttributesToVideoTags();
});
